<template>
     <!-- Sidenav -->
  <nav class="sidenav navbar navbar-vertical  fixed-left  navbar-expand-xs navbar-light bg-white" id="sidenav-main">
    <div class="scrollbar-inner">
      <!-- Brand -->
      <div class="sidenav-header  align-items-center">
        <a class="navbar-brand" href="javascript:void(0)">
          <img src="/assets/img/icons/pointograph-logo-white-2.svg" class="navbar-brand-img" alt="pointograph logo">
        </a>
      </div>
      <div class="navbar-inner">
        <!-- Collapse -->
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <!-- Nav items -->
          <ul class="navbar-nav">
            <li class="nav-item" v-for="(link) in links" :key="link.name">
              <router-link tag="a" :to="link.to" exact replace class="nav-link" :class="[$route.path === link.to ? 'active': '']">
                <i class="ni text-primary" :class="link.icon"></i>
                <span class="nav-link-text">{{link.name}}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      links: [
        { name: 'Dashboard', to: '/dashboard', icon: 'ni-tv-2' },
        { name: 'Places', to: '/dashboard/places', icon: 'ni-pin-3' },
        { name: 'Pages', to: '/dashboard/pages', icon: 'ni-collection' },
        { name: 'Users', to: '/dashboard/users', icon: 'ni-single-02' }
      ]
    }
  }
}
</script>

<style scoped>
a {
  outline: none;
}
</style>
